export default __webpack_public_path__ + "static/media/ctk.d769a6f0.jpg";